// src/frontend/data/books/DarkForest/chaptersData.js

// IMPORTS DE CAPÍTULOS (1..55)
import CAP1 from "./data/cap1";
import CAP2 from "./data/cap2";
import CAP3 from "./data/cap3";
import CAP4 from "./data/cap4";
import CAP5 from "./data/cap5";
import CAP6 from "./data/cap6";
import CAP7 from "./data/cap7";
import CAP8 from "./data/cap8";
import CAP9 from "./data/cap9";
import CAP10 from "./data/cap10";
import CAP11 from "./data/cap11";
import CAP12 from "./data/cap12";
import CAP13 from "./data/cap13";
import CAP14 from "./data/cap14";
import CAP15 from "./data/cap15";
import CAP16 from "./data/cap16";
import CAP17 from "./data/cap17";
import CAP18 from "./data/cap18";
import CAP19 from "./data/cap19";
import CAP20 from "./data/cap20";
import CAP21 from "./data/cap21";
import CAP22 from "./data/cap22";
import CAP23 from "./data/cap23";
import CAP24 from "./data/cap24";
import CAP25 from "./data/cap25";
import CAP26 from "./data/cap26";
import CAP27 from "./data/cap27";
import CAP28 from "./data/cap28";
import CAP29 from "./data/cap29";
import CAP30 from "./data/cap30";
import CAP31 from "./data/cap31";
import CAP32 from "./data/cap32";
import CAP33 from "./data/cap33";
import CAP34 from "./data/cap34";
import CAP35 from "./data/cap35";
import CAP36 from "./data/cap36";
import CAP37 from "./data/cap37";
import CAP38 from "./data/cap38";
import CAP39 from "./data/cap39";
import CAP40 from "./data/cap40";
import CAP41 from "./data/cap41";
import CAP42 from "./data/cap42";
import CAP43 from "./data/cap43";
import CAP44 from "./data/cap44";
import CAP45 from "./data/cap45";
import CAP46 from "./data/cap46";
import CAP47 from "./data/cap47";
import CAP48 from "./data/cap48";
import CAP49 from "./data/cap49";
import CAP50 from "./data/cap50";
import CAP51 from "./data/cap51";
import CAP52 from "./data/cap52";
import CAP53 from "./data/cap53";
import CAP54 from "./data/cap54";
import CAP55 from "./data/cap55";

/**
 * Solo datos, sin componentes, para evitar dependencias circulares.
 * Luego el viewer los convierte en componentes.
 */
export const DARK_FOREST_CAPS = {
  cap1: CAP1,
  cap2: CAP2,
  cap3: CAP3,
  cap4: CAP4,
  cap5: CAP5,
  cap6: CAP6,
  cap7: CAP7,
  cap8: CAP8,
  cap9: CAP9,
  cap10: CAP10,
  cap11: CAP11,
  cap12: CAP12,
  cap13: CAP13,
  cap14: CAP14,
  cap15: CAP15,
  cap16: CAP16,
  cap17: CAP17,
  cap18: CAP18,
  cap19: CAP19,
  cap20: CAP20,
  cap21: CAP21,
  cap22: CAP22,
  cap23: CAP23,
  cap24: CAP24,
  cap25: CAP25,
  cap26: CAP26,
  cap27: CAP27,
  cap28: CAP28,
  cap29: CAP29,
  cap30: CAP30,
  cap31: CAP31,
  cap32: CAP32,
  cap33: CAP33,
  cap34: CAP34,
  cap35: CAP35,
  cap36: CAP36,
  cap37: CAP37,
  cap38: CAP38,
  cap39: CAP39,
  cap40: CAP40,
  cap41: CAP41,
  cap42: CAP42,
  cap43: CAP43,
  cap44: CAP44,
  cap45: CAP45,
  cap46: CAP46,
  cap47: CAP47,
  cap48: CAP48,
  cap49: CAP49,
  cap50: CAP50,
  cap51: CAP51,
  cap52: CAP52,
  cap53: CAP53,
  cap54: CAP54,
  cap55: CAP55,
};
